import React, { memo } from 'react';

import { InfoCircleOutlined as InfoOutlined } from '@ant-design/icons';
import { Alert, Col } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

interface IProps {
  productId: number | string;
}

const ShareableLinks = ({ productId }: IProps) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  return (
    <Col span={24}>
      <div className='my-9 [&_table]:mt-4 [&_table]:w-full [&_table]:max-w-[100vw] [&_table]:bg-[#F5F5F5] [&_table]:p-2 [&_tbody_tr]:bg-white max-sm:[&_tbody_tr]:flex max-sm:[&_tbody_tr]:flex-col [&_td]:px-2 [&_th]:pb-2 [&_th]:text-left [&_th]:font-normal [&>strong]:mb-4 [&>strong]:block'>
        <strong>Link para divulgação</strong>

        <Alert
          icon={<InfoOutlined />}
          type='info'
          className='hash-alert'
          message='Seus novos links de Checkout, agora, seguem o padrão de oferta base do MyEduzz. Essa alteração não compromete seus links já criados.'
        />

        {isMobile && (
          <div className='mt-8 flex flex-col gap-2 [&>div]:grow'>
            <div>Novo Checkout</div>
            <CustomCopyToClipboard text={`${CHECKOUT_ELEMENTS_URL}/${productId}`} hideInput />
            <div>Antigo Checkout</div>
            <CustomCopyToClipboard text={`${CHECKOUT_SUN_URL}/${productId}`} hideInput />
          </div>
        )}

        {!isMobile && (
          <table>
            <thead>
              <tr>
                <th>Checkout</th>
                <th>Página de pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Novo</td>
                <td>
                  <CustomCopyToClipboard text={`${CHECKOUT_ELEMENTS_URL}/${productId}`} hideInput />
                </td>
              </tr>
              <tr>
                <td width='160'>Antigo</td>
                <td>
                  <CustomCopyToClipboard text={`${CHECKOUT_SUN_URL}/${productId}`} hideInput />
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </Col>
  );
};

export default memo(ShareableLinks);
